// Aquí están los thunks relacionados con el registro de usuarios
import { createAsyncThunk } from "@reduxjs/toolkit";
import store from "@/app/store";
import api from "@/services/api";
// Slice para crear empresa
import {
  crearEmpresaSuccess,
  crearEmpresaFailure,
  crearEmpresaReset,
} from "./crearEmpresaSlice";
// Slice para activar empresa
import {
  activarEmpresaSuccess,
  activarEmpresaFailure,
  activarEmpresaReset,
} from "./activarEmpresaSlice";

// Slice para empresa
import {
  empresaSuccess,
  empresaFailure,
  empresaReset,
} from "./empresaSlice";

/**
 * 📝 EMPRESA — Crear Empresa
 */
export const crearEmpresa = createAsyncThunk(
  "empresa/crearEmpresa",
  async (empresaData, { dispatch, rejectWithValue }) => {
    const uid = store.getState().auth.user?.uid; // TODO: Valorar si dejar esto o usar el idUsuario que viene en empresaData
    if (!uid) {
      return rejectWithValue("UID de usuario no disponible");
    }
    console.log("Empresa Data in Thunk:", empresaData);
    // debugger;
    // Crear FormData para enviar la imagen de perfil y portada junto con los demás datos
    const formData = new FormData();
    formData.append("nombre", empresaData.nombre);
    formData.append("categoria", empresaData.categoria);
    formData.append("descripcion", empresaData.descripcion);
    formData.append("siubicacionfisica", empresaData.siubicacionfisica);
    formData.append("direccion", empresaData.direccion);
    formData.append("pais", empresaData.pais);
    formData.append("ciudad", empresaData.ciudad);
    formData.append("comuna", empresaData.comuna);
    formData.append("codigopostal", empresaData.codigopostal);
    formData.append("horario", empresaData.horario);
    formData.append("portada", empresaData.portada);
    formData.append("imagenperfil", empresaData.imagenperfil);
    formData.append("id", empresaData.idUsuario);

    try {
      const { data } = await api.post("/empresas/crear", formData,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch(crearEmpresaSuccess({ info: data }));
      // debugger;
      return data;
    } catch (err) {
      console.error("Error al crear la empresa:", err);
      dispatch(
        crearEmpresaFailure(
          err.response?.data ||
            err.response?.data?.message ||
            "Error al crear la empresa"
        )
      );
      return rejectWithValue(
        err.response?.data || err.response?.data?.message || "Error al crear la empresa"
      );
    }
  }
);

/** 📝 EMPRESA — Activar Empresa
 */
export const activarEmpresa = createAsyncThunk(
  "empresa/activarEmpresa",
  async (empresaData, { dispatch, rejectWithValue }) => {
    try {
      console.log("Activar Empresa Data in Thunk:", empresaData);
      
      // Crear FormData para enviar los archivos junto con los demás datos
      const formData = new FormData();
      
      // Agregar campos de texto
      formData.append("uidEmpresa", empresaData.uidEmpresa);
      formData.append("empresa_type", empresaData.empresa_type);
      formData.append("rut_text", empresaData.rut_text);
      
      // Agregar archivos obligatorios
      if (empresaData.Frente_cedula_identidad) {
        formData.append("Frente_cedula_identidad", empresaData.Frente_cedula_identidad);
      }
      if (empresaData.Dorso_cedula_identidad) {
        formData.append("Dorso_cedula_identidad", empresaData.Dorso_cedula_identidad);
      }
      if (empresaData.cuenta_bancaria) {
        formData.append("cuenta_bancaria", empresaData.cuenta_bancaria);
      }
      
      // Agregar archivos opcionales según tipo de empresa
      if (empresaData.empresa_type === "Persona Jurídica") {
        if (empresaData.rut_file) {
          formData.append("rut_file", empresaData.rut_file);
        }
        if (empresaData.escritura_sociedad) {
          formData.append("escritura_sociedad", empresaData.escritura_sociedad);
        }
      }

      const { data } = await api.post("/empresas/activar", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      
      dispatch(activarEmpresaSuccess({ info: data }));
      return data;
    } catch (err) {
      console.error("Error al activar la empresa:", err);
      const errorMessage = err.response?.data?.message || 
                          err.response?.data?.error ||
                          "Error al activar la empresa";
      dispatch(activarEmpresaFailure(errorMessage));
      return rejectWithValue(errorMessage);
    }
  }
);

/**
 * 📝 EMPRESA — Obtener información de la empresa del empresa
 */
export const getEmpresaInfo = createAsyncThunk(
  "empresa/getEmpresaInfo",
  async ({ uid }, { dispatch, rejectWithValue }) => {
    try {
      if (!uid) {
        throw new Error("UID de empresa no disponible");
      }
      const { data } = await api.get(`/empresas/${uid}`);
      dispatch(empresaSuccess({ infoEmpresa: data }));
      return data;
    } catch (err) {
      console.error("Error al obtener información de la empresa:", err);
      dispatch(
        empresaFailure(
          err.response?.data ||
            err.response?.data?.message ||
            "Error al obtener información de la empresa"
        )
      );
      return rejectWithValue(
        err.response?.data || err.response?.data?.message || "Error al obtener información de la empresa"
      );
    }
  }
);

export const getEmpresaEventos = createAsyncThunk(
  "empresa/getEmpresaEventos",
  async ({ uid, filters = {}, page = 1, limit = 10 }, { dispatch, rejectWithValue }) => {
    const { infoEmpresa } = store.getState().empresa;
    try {
      if (!uid) {
        throw new Error("UID de empresa no disponible");
      }
      
      // Construir query params
      const params = new URLSearchParams();
      
      // Agregar filtros si existen
      if (filters.published !== undefined) params.append('published', filters.published);
      if (filters.enabled !== undefined) params.append('enabled', filters.enabled);
      if (filters.fechaHoraInicioDesde) params.append('fechaHoraInicioDesde', filters.fechaHoraInicioDesde);
      if (filters.fechaHoraInicioHasta) params.append('fechaHoraInicioHasta', filters.fechaHoraInicioHasta);
      if (filters.fechaHoraFinDesde) params.append('fechaHoraFinDesde', filters.fechaHoraFinDesde);
      if (filters.fechaHoraFinHasta) params.append('fechaHoraFinHasta', filters.fechaHoraFinHasta);
      if (filters.createdAtDesde) params.append('createdAtDesde', filters.createdAtDesde);
      if (filters.createdAtHasta) params.append('createdAtHasta', filters.createdAtHasta);
      
      // Agregar ordenamiento si existe
      if (filters.sortBy) params.append('sortBy', filters.sortBy);
      if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);
      
      // Agregar paginación
      params.append('page', page);
      params.append('limit', limit);
      
      const queryString = params.toString();
      const { data } = await api.get(`/empresas/${uid}/eventos${queryString ? `?${queryString}` : ''}`);
      
      dispatch(empresaSuccess({ infoEmpresa: { ...infoEmpresa, eventos: data } }));
      return data;
    } catch (err) {
      console.error("Error al obtener eventos de la empresa:", err);
      dispatch(empresaFailure(
        err.response?.data ||
          err.response?.data?.message ||
          "Error al obtener eventos de la empresa"
      ));
      return rejectWithValue(
        err.response?.data || err.response?.data?.message || "Error al obtener eventos de la empresa"
      );
    }
  }
);

/**
 * 📝 EMPRESA — Obtener eventos publicados activos (ordenados por fecha de inicio más cercana)
 */
export const getEmpresaEventosPublicadosActivos = createAsyncThunk(
  "empresa/getEmpresaEventosPublicadosActivos",
  async ({ uid, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      if (!uid) {
        throw new Error("UID de empresa no disponible");
      }
      
      const now = new Date().toISOString();
      
      const params = new URLSearchParams({
        published: 'true',
        enabled: 'true',
        fechaHoraFinDesde: now, // Solo eventos que aún no han terminado
        sortBy: 'fechaHoraInicio',
        sortOrder: 'asc', // Más cercano primero
        page: page.toString(),
        limit: limit.toString()
      });
      
      const { data } = await api.get(`/empresas/${uid}/eventos?${params.toString()}`);
      return data;
    } catch (err) {
      console.error("Error al obtener eventos publicados activos:", err);
      return rejectWithValue(
        err.response?.data || err.response?.data?.message || "Error al obtener eventos publicados activos"
      );
    }
  }
);

/**
 * 📝 EMPRESA — Obtener eventos no publicados (ordenados por fecha de creación más vieja primero)
 */
export const getEmpresaEventosPorPublicar = createAsyncThunk(
  "empresa/getEmpresaEventosPorPublicar",
  async ({ uid, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      if (!uid) {
        throw new Error("UID de empresa no disponible");
      }
      
      const params = new URLSearchParams({
        published: 'false',
        sortBy: 'createdAt',
        sortOrder: 'asc', // Más viejo primero
        page: page.toString(),
        limit: limit.toString()
      });
      
      const { data } = await api.get(`/empresas/${uid}/eventos?${params.toString()}`);
      return data;
    } catch (err) {
      console.error("Error al obtener eventos no publicados:", err);
      return rejectWithValue(
        err.response?.data || err.response?.data?.message || "Error al obtener eventos no publicados"
      );
    }
  }
);

/**
 * 📝 EMPRESA — Obtener eventos publicados finalizados (fechaHoraFin ya pasó)
 */
export const getEmpresaEventosFinalizados = createAsyncThunk(
  "empresa/getEmpresaEventosFinalizados",
  async ({ uid, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      if (!uid) {
        throw new Error("UID de empresa no disponible");
      }
      
      const now = new Date().toISOString();
      
      const params = new URLSearchParams({
        published: 'true',
        fechaHoraFinHasta: now, // Solo eventos que ya terminaron
        sortBy: 'fechaHoraFin',
        sortOrder: 'desc', // Más recientes primero
        page: page.toString(),
        limit: limit.toString()
      });
      
      const { data } = await api.get(`/empresas/${uid}/eventos?${params.toString()}`);
      return data;
    } catch (err) {
      console.error("Error al obtener eventos finalizados:", err);
      return rejectWithValue(
        err.response?.data || err.response?.data?.message || "Error al obtener eventos finalizados"
      );
    }
  }
);

/**
 * 📝 EMPRESA — Actualizar información de una empresa
 */
export const updateInfoEmpresa = createAsyncThunk(
  "empresa/updateInfoEmpresa",
  async ({ empresaUid, formData }, { dispatch, getState, rejectWithValue }) => {
    try {
      const response = await api.put(`/empresas/${empresaUid}`, formData);
      
      // Merge the updated data with existing state
      const currentEmpresa = getState().empresa.infoEmpresa;
      const updatedEmpresa = {
        ...currentEmpresa,
        ...response.data.empresa
      };
      
      dispatch(empresaSuccess({ infoEmpresa: updatedEmpresa }));
      return response.data;
    } catch (error) {
      dispatch(empresaFailure(error.response?.data?.message || "Error al actualizar la empresa"));
      return rejectWithValue(
        error.response?.data?.message || "Error al actualizar la empresa"
      );
    }
  }
);

/**
 * 📝 EMPRESA — Actualizar Imagen de Perfil de la empresa
 */
export const updateImgPerfilEmpresa = createAsyncThunk(
  "empresa/updateImgPerfilEmpresa",
  async ({ empresaUid, imageFile }, { dispatch, rejectWithValue }) => {
    try {
      if (!empresaUid) {
        throw new Error("UID de empresa no disponible");
      }

      const formData = new FormData();
      formData.append("imgPerfil", imageFile);

      const { data } = await api.patch(`/empresas/${empresaUid}/imgPerfil`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // Refrescar información completa de la empresa para obtener la URL actualizada
      await dispatch(getEmpresaInfo({ uid: empresaUid }));

      return data;
    } catch (err) {
      console.error("Error al actualizar imagen de perfil de empresa:", err);
      return rejectWithValue(
        err.response?.data?.message || "Error al actualizar imagen de perfil de empresa"
      );
    }
  }
);

/**
 * 📝 EMPRESA — Actualizar Imagen de portada de la empresa
 */
export const updateImgPortadaEmpresa = createAsyncThunk(
  "empresa/updateImgPortadaEmpresa",
  async ({ empresaUid, imageFile }, { dispatch, rejectWithValue }) => {
    try {
      if (!empresaUid) {
        throw new Error("UID de empresa no disponible");
      }

      const formData = new FormData();
      formData.append("imgPortada", imageFile);

      const { data } = await api.patch(`/empresas/${empresaUid}/imgPortada`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // Refrescar información completa de la empresa para obtener la URL actualizada
      await dispatch(getEmpresaInfo({ uid: empresaUid }));

      return data;
    } catch (err) {
      console.error("Error al actualizar imagen de portada de empresa:", err);
      return rejectWithValue(
        err.response?.data?.message || "Error al actualizar imagen de portada de empresa"
      );
    }
  }
);